module.exports = __webpack_public_path__ + "static/img/yz.53c7304.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yz.png
// module id = Npit
// module chunks = 1